import React from 'react';
import * as style from '../Hooks/style';
import Conditional from "../Hooks/ConditionalRender";
import diamond from '../Images/section4_diamond.png';

export const Sect4 = ({fref, active4}) => {
  return (
    <style.Section4 ref={fref}>
      <Conditional if={active4 === true}>
        <section className="s4first">
          <h3>Our Product</h3>
          <h2>A.I Chartering</h2>
        </section>
        <section className="s4second">
          <img src={diamond} alt="diamond" />
          <p color="green">Empower</p>
          <p>Empower your people to the highest performance standard</p>
        </section>
        <section className="s4second">
          <img src={diamond} alt="diamond" />
          <p>Dominate</p>
          <p>Dominate your maritime date with the simplest touch</p>
        </section>
        <section className="s4second">
          <img src={diamond} alt="diamond" />
          <p>Utilization</p>
          <p>Utilization your resources to the maximum capacity</p>
        </section>
        <p className="s4last">Use A.I. Like Never Before.</p>
      </Conditional>
    </style.Section4>
  );
}